import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of, ReplaySubject } from 'rxjs';
import FormHelper from '../helpers/form.helper';
import { LoginResultModel } from '../models/api/login-result.model';
import { UniversalStorage } from '../storages/universal.storage';

@Injectable({
    providedIn: 'root'
})
export class AuthenticationService {
  private static readonly authenticationKey = 'levante.authentication';
  private authenticatedModel: string | null = null;
  private tokenExpirationDate: number | null = null;
  private refreshTokenExpirationDate: number | null = null;
  public $authenticated = new ReplaySubject<string | null>(1);

  constructor(private readonly universalStorage: UniversalStorage,
    private readonly route: ActivatedRoute,
    private readonly router: Router,) {
    const authenticatedModel = this.universalStorage.getItemFromObject<string>(AuthenticationService.authenticationKey);

    this.setLoginInfo(authenticatedModel);
  }

  public setLoginInfo(data: string | null): void {
    this.authenticatedModel = data;

    if (data) {
      this.universalStorage.setItemFromObject<string>(AuthenticationService.authenticationKey, data);
      this.tokenExpirationDate = this.getExpirationDateFromToken(data);
      //this.refreshTokenExpirationDate = this.getExpirationDateFromToken(data.refreshToken);
    }
    else {
      // remove the items if data was null or undefined
      this.universalStorage.removeItem(AuthenticationService.authenticationKey);
      this.tokenExpirationDate = null;
      this.refreshTokenExpirationDate = null;
    }

    this.$authenticated.next(this.authenticatedModel);
  }

  public logout(): void {
    this.setLoginInfo(null);
  }

  public navigateToLogin(): void {
    // Redirect to current url and trigger the authorization guard
    FormHelper.redirectToSelf(this.router);
  }
  
  public getToken(): string | null {
    return this.authenticatedModel;
    //return this.authenticatedModel?.token ?? null;
  }

  public getRefreshToken(): string | null {
    return null;
    //return this.authenticatedModel?.refreshToken ?? null;
  }

  public tokenExpired(): boolean {
    if (!this.tokenExpirationDate) {
      return true;
    }
    
    return this.isExpired(this.tokenExpirationDate);
  }

  private refreshTokenExpired(): boolean {
    if (!this.refreshTokenExpirationDate) {
      return true;
    }
    
    return this.isExpired(this.refreshTokenExpirationDate);
  }

  private getExpirationDateFromToken(token: string): number {
    return JSON.parse(this.b64decode(token.split('.')[1])).exp;
  }

  private isExpired(expirationDate: number): boolean {
    return Math.floor(new Date().getTime() / 1000) >= expirationDate;
  }

  private b64decode(str: string): string {
    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    let output: string = '';

    str = String(str).replace(/=+$/, '');

    if (str.length % 4 == 1) {
      throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
    }

    for (
      // initialize result and counters
      let bc: number = 0, bs: any, buffer: any, idx: number = 0;
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  }

  public getRoles(): string[] | null {
    return [];
    //return this.authenticatedModel?.roleKeys ?? null;
  }

  public getRights(): string[] | null {
    return [];
    //return this.authenticatedModel?.rightKeys ?? null;
  }

  public hasRight(right: string): boolean {
    return false;
    /*if (!this.authenticatedModel) {
      return false;
    }

    return this.authenticatedModel.rightKeys.includes(right);*/
  }

  public hasAnyRight(rights: string[]): boolean {
    return false;
    /*if (!this.authenticatedModel) {
      return false;
    }

    return this.authenticatedModel.rightKeys.some(right => rights.includes(right));*/
  }

  public isAuthenticated(): boolean {
    return !this.tokenExpired();
  }

  authenticate(loginName: string, password: string): Observable<LoginResultModel | null> {
    return of(null);
    /*const model: LoginModel = {
      identifier: loginName,
      password: password
    };

    if (model) {
      return this.apiAuthenticationService.authenticate(model)
        .pipe(tap((result: LoginResultModel | null) => {
            this.setLoginInfo(result);
            return result;
      }));
    }
    else {
        return of(null)
    }*/
  }

  refreshToken(): Observable<LoginResultModel | null> {
    return of(null);
    /*const refreshToken = this.getRefreshToken();

    if (refreshToken) {
      if (this.refreshTokenExpired()) {
        this.logout();
        return of(null);
      }

      const refreshModel: RefreshAuthenticationModel = {
        refreshToken: refreshToken
      };

      return this.apiAuthenticationService.refreshToken(refreshModel)
        .pipe(tap((result: AuthenticationModel | null) => {
          this.setLoginInfo(result);

          return result;
        }),
          catchError(error => {
            // Logout if the refresh token was not valid
            this.logout();

            return throwError(error);
          })
        );
    }
    else {
      return of(null)
    }*/
  }
}
